import { ChevronRight, Warehouse } from 'lucide-react';
import { OrganizationWarehousesButtonProps } from './types';

const OrganizationWarehousesButton = (props: OrganizationWarehousesButtonProps) => {
  const {
    onOpenOrganizationWarehouses
  } = props;

  return (
    <button
      className="flex w-full items-center gap-2 p-4 text-left rounded-2xl border border-border-strong bg-surface transition-colors hover:bg-accent-soft/60 active:bg-[#F3F5FF] dark:active:bg-[#201F27] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      onClick={onOpenOrganizationWarehouses}
      type="button"
    >
      <span className="flex size-8 shrink-0 items-center justify-center rounded-[8px] bg-[#13100d0d] dark:bg-[#ffffff0d]">
        <Warehouse className="size-4 text-foreground" />
      </span>
      <span className="min-w-0 flex-1 truncate font-sans text-sm font-semibold leading-5 tracking-normal text-foreground">
        Склады организации
      </span>
      <ChevronRight className="size-5 shrink-0 text-muted-foreground" />
    </button>
  );
};

export default OrganizationWarehousesButton;